import { render, staticRenderFns } from "./ResultContinueBonus.vue?vue&type=template&id=3837ed0a&scoped=true"
import script from "./ResultContinueBonus.vue?vue&type=script&lang=js"
export * from "./ResultContinueBonus.vue?vue&type=script&lang=js"
import style0 from "./ResultContinueBonus.vue?vue&type=style&index=0&id=3837ed0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837ed0a",
  null
  
)

export default component.exports